export const CLEAR_OPPORTUNITY = 'Opportunities/CLEAR_OPPORTUNITY';
export const CLEAR_SEARCH_OPPORTUNITIES = 'Opportunities/CLEAR_SEARCH_OPPORTUNITIES';

export const EMPTY_OPPORTUNITIES = 'Opportunities/EMPTY_OPPORTUNITIES';

export const FETCH_OPPORTUNITY = 'Opportunities/FETCH_OPPORTUNITY';
export const FETCH_OPPORTUNITY_SUCCESS = 'Opportunities/FETCH_OPPORTUNITY_SUCCESS';
export const FETCH_OPPORTUNITY_FAILURE = 'Opportunities/FETCH_OPPORTUNITY_FAILURE';

export const FETCH_OPPORTUNITIES = 'Opportunities/FETCH_OPPORTUNITIES';
export const FETCH_OPPORTUNITIES_SUCCESS = 'Opportunities/FETCH_OPPORTUNITIES_SUCCESS';
export const FETCH_OPPORTUNITIES_FAILURE = 'Opportunities/FETCH_OPPORTUNITIES_FAILURE';

export const REMOVE_OPPORTUNITY = 'Opportunities/REMOVE_OPPORTUNITY';
export const REMOVE_OPPORTUNITY_SUCCESS = 'Opportunities/REMOVE_OPPORTUNITY_SUCCESS';
export const REMOVE_OPPORTUNITY_FAILURE = 'Opportunities/REMOVE_OPPORTUNITY_FAILURE';

export const SAVE_OPPORTUNITY = 'Opportunities/SAVE_OPPORTUNITY';
export const SAVE_OPPORTUNITY_SUCCESS = 'Opportunities/SAVE_OPPORTUNITY_SUCCESS';
export const SAVE_OPPORTUNITY_FAILURE = 'Opportunities/SAVE_OPPORTUNITY_FAILURE';

export const SET_OPPORTUNITY = 'Opportunities/SET_OPPORTUNITY';
export const SET_OPPORTUNITIES_FILTERS = 'Opportunities/SET_OPPORTUNITIES_FILTERS';
export const SET_OPPORTUNITIES_SEARCH_FIELD = 'Opportunities/SET_OPPORTUNITIES_SEARCH_FIELD';
export const SET_OPPORTUNITY_EMPTY_STATE = 'Opportunities/SET_OPPORTUNITY_EMPTY_STATE';

export const UPDATE_OPPORTUNITIES = 'Opportunities/UPDATE_OPPORTUNITIES';

export const SEARCH_OPPORTUNITIES = 'Opportunities/SEARCH_OPPORTUNITIES';
export const SEARCH_OPPORTUNITIES_SUCCESS = 'Opportunities/SEARCH_OPPORTUNITIES_SUCCESS';
export const SEARCH_OPPORTUNITIES_FAILURE = 'Opportunities/SEARCH_OPPORTUNITIES_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/Opportunities/store/constants.js